import { FormControlLabel, InputLabel, Radio, RadioGroup } from '@mui/material';
import React from 'react';
import { getMessage } from '@shared/utils';
import type { UseFormRegister } from 'react-hook-form';

interface FieldOption {
  v: string | number;
  lbl: string;
}

interface Field {
  name: string;
  label?: string;
  lbl: string;
  m?: boolean;
  dV?: string | number;
  i?: FieldOption[];
}

interface CustomRadioButtonProps {
  field: Field;
  register: UseFormRegister<any>;
  errors?: string;
  orientation?: boolean;
}

const CustomRadioButton: React.FC<CustomRadioButtonProps> = ({ field, register, errors, orientation = true }) => {
  const validators = {
    required: {
      value: field?.m || false,
      message: getMessage('requiredField'),
    },
  };
  const { ref, ...registration } = register(field?.name, validators);

  return (
    <>
      <InputLabel id={`${field?.name}-${field?.label}`}>{field?.lbl}</InputLabel>
      <RadioGroup
        row={orientation}
        aria-labelledby={`${field?.name}-${field?.label}`}
        defaultValue={field?.dV}
        name={field?.name}
      >
        {field.i?.map((fld) => (
          <FormControlLabel
            style={{ margin: 10, color: 'black' }}
            key={String(fld.v)}
            value={fld?.v}
            control={
              <Radio slotProps={{ input: { ref } }} {...registration} />
            }
            label={fld?.lbl}
          />
        ))}
      </RadioGroup>
      <p style={{ color: 'red', margin: '0px', fontSize: '14px' }}>{errors}</p>
    </>
  );
};

export default CustomRadioButton;
